"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BORDER_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.BATTLESHIP;
  }
});
Object.defineProperty(exports, "DISABLED_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.FLINT;
  }
});
Object.defineProperty(exports, "FOREGROUND_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.OBSIDIAN;
  }
});
Object.defineProperty(exports, "FOREGROUND_FOCUS_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.EERIE;
  }
});
Object.defineProperty(exports, "ENCLOSED_BACKGROUND_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.GYPSUM;
  }
});
Object.defineProperty(exports, "ENCLOSED_SELECTED_BACKGROUND_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.OLAF;
  }
});
Object.defineProperty(exports, "ENCLOSED_SELECTED_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.GYPSUM;
  }
});
Object.defineProperty(exports, "ENCLOSED_SHADED_BACKGROUND_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.KOALA;
  }
});
Object.defineProperty(exports, "ENCLOSED_SHADED_SELECTED_BACKGROUND_COLOR", {
  enumerable: true,
  get: function get() {
    return _colors.GYPSUM;
  }
});

var _colors = require("HubStyleTokens/colors");